var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.currentStep,
            callback: function($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep"
          }
        },
        [
          _c(
            "v-stepper-header",
            [
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.currentStep > 1, step: "1" } },
                [_vm._v("\n        Create Username/Password login\n      ")]
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              !_vm.invitation
                ? _c(
                    "v-stepper-step",
                    { attrs: { complete: _vm.currentStep > 2, step: "2" } },
                    [
                      _vm._v(
                        "\n        Name, Company Name, Phone Number\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invitation === "driver"
                ? _c(
                    "v-stepper-step",
                    { attrs: { complete: _vm.currentStep > 2, step: "2" } },
                    [_vm._v("\n        CDL Info\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              !_vm.invitation
                ? _c(
                    "v-stepper-step",
                    { attrs: { complete: _vm.currentStep > 2, step: "3" } },
                    [_vm._v("\n        What kind of company?\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("v-stepper-step", { attrs: { step: "4" } }, [
                _vm._v("\n        Explore\n      ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-stepper-items",
            [
              _c(
                "v-stepper-content",
                { attrs: { step: "1" } },
                [
                  _c(
                    "form",
                    { attrs: { "data-vv-scope": "step1" } },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "pb-3 mb-1" },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c(
                                "div",
                                { staticClass: "subheading font-weight-bold" },
                                [
                                  _vm._v(
                                    "\n                Create account\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-alert",
                                {
                                  staticClass: "my-2",
                                  attrs: {
                                    value: _vm.accountErrors,
                                    type: "error"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.accountErrors) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|email",
                                    expression: "'required|email'"
                                  }
                                ],
                                attrs: {
                                  label: "Email address",
                                  disabled: _vm.signedIn,
                                  "error-messages": _vm.errors.first(
                                    "email",
                                    "step1"
                                  ),
                                  "data-vv-as": "Email address",
                                  "data-vv-name": "email",
                                  "data-vv-scope": "step1"
                                },
                                model: {
                                  value: _vm.userName,
                                  callback: function($$v) {
                                    _vm.userName = $$v
                                  },
                                  expression: "userName"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min:8",
                                    expression: "'required|min:8'"
                                  }
                                ],
                                attrs: {
                                  "append-icon": _vm.showPass
                                    ? "visibility_off"
                                    : "visibility",
                                  type: _vm.showPass ? "text" : "password",
                                  disabled: _vm.signedIn,
                                  name: "password",
                                  "error-messages": _vm.errors.first(
                                    "password",
                                    "step1"
                                  ),
                                  "data-vv-name": "password",
                                  label: "Password",
                                  "data-vv-as": "Password",
                                  "data-vv-scope": "step1",
                                  counter: ""
                                },
                                on: {
                                  "click:append": function($event) {
                                    _vm.showPass = !_vm.showPass
                                  }
                                },
                                model: {
                                  value: _vm.password,
                                  callback: function($$v) {
                                    _vm.password = $$v
                                  },
                                  expression: "password"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", loading: _vm.loadingBtn },
                      on: {
                        click: function($event) {
                          return _vm.nextStep("step1")
                        }
                      }
                    },
                    [_vm._v("\n            Continue\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.$router.push(-1)
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    { attrs: { "offset-y": "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            slot: "activator",
                            color: "primary",
                            flat: "",
                            small: ""
                          },
                          slot: "activator"
                        },
                        [_vm._v("\n              Advanced Login\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-tile",
                            { on: { click: _vm.googleSignIn } },
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                  Log in with Google\n                "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.referrer.displayName
                    ? _c(
                        "v-layout",
                        [
                          _c("v-flex", { staticClass: "mt-4" }, [
                            _vm._v(
                              "\n              *You are being referred by " +
                                _vm._s(_vm.referrer.displayName) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.invitation
                ? _c(
                    "v-stepper-content",
                    { attrs: { step: "2" } },
                    [
                      _c(
                        "form",
                        { attrs: { "data-vv-scope": "step2" } },
                        [
                          _c(
                            "v-layout",
                            { staticClass: "pb-3" },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "", "px-3": "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "subheading font-weight-bold"
                                    },
                                    [
                                      _vm._v(
                                        "\n                Personal Information\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      label: "Name",
                                      "error-messages": _vm.errors.first(
                                        "name",
                                        "step2"
                                      ),
                                      "data-vv-name": "name",
                                      "data-vv-as": "Name",
                                      "data-vv-scope": "step2",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.name,
                                      callback: function($$v) {
                                        _vm.name = $$v
                                      },
                                      expression: "name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "subheading font-weight-bold mt-2"
                                    },
                                    [
                                      _vm._v(
                                        "\n                Company Information\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      label: "Company Name",
                                      "error-messages": _vm.errors.first(
                                        "companyName",
                                        "step2"
                                      ),
                                      "data-vv-as": "Company name",
                                      "data-vv-name": "companyName",
                                      "data-vv-scope": "step2",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.companyName,
                                      callback: function($$v) {
                                        _vm.companyName = $$v
                                      },
                                      expression: "companyName"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      label: "Phone Number",
                                      "data-vv-as": "Phone Number",
                                      "data-vv-name": "phone",
                                      "data-vv-scope": "step2",
                                      "error-messages": _vm.errors.first(
                                        "phone",
                                        "step2"
                                      ),
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.phone,
                                      callback: function($$v) {
                                        _vm.phone = $$v
                                      },
                                      expression: "phone"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent" },
                          on: {
                            click: function($event) {
                              return _vm.nextStep("step2")
                            }
                          }
                        },
                        [_vm._v("\n          Continue\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.currentStep = 1
                            }
                          }
                        },
                        [_vm._v("Back")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invitation === "driver"
                ? _c(
                    "v-stepper-content",
                    { attrs: { step: "2" } },
                    [
                      _c(
                        "form",
                        { attrs: { "data-vv-scope": "step2" } },
                        [
                          _c(
                            "v-layout",
                            { staticClass: "pb-3" },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "", "px-3": "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "subheading font-weight-bold"
                                    },
                                    [
                                      _vm._v(
                                        "\n                Add your CDL information to your Profile so loads can be assigned to you.\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mr-5",
                                          attrs: { sm6: "" }
                                        },
                                        [
                                          _c(
                                            "v-menu",
                                            {
                                              ref: "cdlExpiresDateMenu",
                                              attrs: {
                                                "close-on-content-click": false,
                                                "nudge-right": 40,
                                                "return-value": _vm.cdlExpires,
                                                lazy: "",
                                                transition: "scale-transition",
                                                "offset-y": "",
                                                "full-width": "",
                                                "min-width": "290px"
                                              },
                                              on: {
                                                "update:returnValue": function(
                                                  $event
                                                ) {
                                                  _vm.cdlExpires = $event
                                                },
                                                "update:return-value": function(
                                                  $event
                                                ) {
                                                  _vm.cdlExpires = $event
                                                }
                                              },
                                              model: {
                                                value: _vm.cdlExpiresDateMenu,
                                                callback: function($$v) {
                                                  _vm.cdlExpiresDateMenu = $$v
                                                },
                                                expression: "cdlExpiresDateMenu"
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  slot: "activator",
                                                  label: "CDL Expires",
                                                  "prepend-icon": "event",
                                                  readonly: ""
                                                },
                                                slot: "activator",
                                                model: {
                                                  value: _vm.cdlExpires,
                                                  callback: function($$v) {
                                                    _vm.cdlExpires = $$v
                                                  },
                                                  expression: "cdlExpires"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "v-date-picker",
                                                {
                                                  attrs: {
                                                    "no-title": "",
                                                    scrollable: ""
                                                  },
                                                  model: {
                                                    value: _vm.cdlExpires,
                                                    callback: function($$v) {
                                                      _vm.cdlExpires = $$v
                                                    },
                                                    expression: "cdlExpires"
                                                  }
                                                },
                                                [
                                                  _c("v-spacer"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        flat: "",
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.cdlExpiresDateMenu = false
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Cancel\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        flat: "",
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$refs.cdlExpiresDateMenu.save(
                                                            _vm.cdlExpires
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        OK\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mr-5",
                                          attrs: { sm6: "" }
                                        },
                                        [
                                          _c(
                                            "v-menu",
                                            {
                                              ref: "medicalExpiresDateMenu",
                                              attrs: {
                                                "close-on-content-click": false,
                                                "nudge-right": 40,
                                                "return-value":
                                                  _vm.medicalExpires,
                                                lazy: "",
                                                transition: "scale-transition",
                                                "offset-y": "",
                                                "full-width": "",
                                                "min-width": "290px"
                                              },
                                              on: {
                                                "update:returnValue": function(
                                                  $event
                                                ) {
                                                  _vm.medicalExpires = $event
                                                },
                                                "update:return-value": function(
                                                  $event
                                                ) {
                                                  _vm.medicalExpires = $event
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.medicalExpiresDateMenu,
                                                callback: function($$v) {
                                                  _vm.medicalExpiresDateMenu = $$v
                                                },
                                                expression:
                                                  "medicalExpiresDateMenu"
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  slot: "activator",
                                                  label: "Medical Expires",
                                                  "prepend-icon": "event",
                                                  readonly: ""
                                                },
                                                slot: "activator",
                                                model: {
                                                  value: _vm.medicalExpires,
                                                  callback: function($$v) {
                                                    _vm.medicalExpires = $$v
                                                  },
                                                  expression: "medicalExpires"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "v-date-picker",
                                                {
                                                  attrs: {
                                                    "no-title": "",
                                                    scrollable: ""
                                                  },
                                                  model: {
                                                    value: _vm.medicalExpires,
                                                    callback: function($$v) {
                                                      _vm.medicalExpires = $$v
                                                    },
                                                    expression: "medicalExpires"
                                                  }
                                                },
                                                [
                                                  _c("v-spacer"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        flat: "",
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.medicalExpiresDateMenu = false
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Cancel")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        flat: "",
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$refs.medicalExpiresDateMenu.save(
                                                            _vm.medicalExpires
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        OK\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent" },
                          on: {
                            click: function($event) {
                              return _vm.saveCDLInfo("step2")
                            }
                          }
                        },
                        [_vm._v("\n          Save\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.currentStep = 1
                            }
                          }
                        },
                        [_vm._v("Back")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.invitation
                ? _c(
                    "v-stepper-content",
                    { attrs: { step: "3" } },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "pb-3" },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c(
                                "div",
                                { staticClass: "subheading font-weight-bold" },
                                [
                                  _vm._v(
                                    "\n            Tell us a few things about you and " +
                                      _vm._s(_vm.companyName) +
                                      ":\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  staticClass: "pl-3",
                                  attrs: { row: "", wrap: "" }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm6: "", xs12: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "Produce Loads",
                                          value: "Produce Loads"
                                        },
                                        model: {
                                          value: _vm.companyType,
                                          callback: function($$v) {
                                            _vm.companyType = $$v
                                          },
                                          expression: "companyType"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm6: "", xs12: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "Dispatch Loads",
                                          value: "Dispatch Loads"
                                        },
                                        model: {
                                          value: _vm.companyType,
                                          callback: function($$v) {
                                            _vm.companyType = $$v
                                          },
                                          expression: "companyType"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm6: "", xs12: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "Stockyard",
                                          value: "Stockyard"
                                        },
                                        model: {
                                          value: _vm.companyType,
                                          callback: function($$v) {
                                            _vm.companyType = $$v
                                          },
                                          expression: "companyType"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm6: "", xs12: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "Kill Plant",
                                          value: "Kill Plant"
                                        },
                                        model: {
                                          value: _vm.companyType,
                                          callback: function($$v) {
                                            _vm.companyType = $$v
                                          },
                                          expression: "companyType"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm6: "", xs12: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "Trucking Company (Fleet)",
                                          value: "Trucking Company / Fleet"
                                        },
                                        model: {
                                          value: _vm.companyType,
                                          callback: function($$v) {
                                            _vm.companyType = $$v
                                          },
                                          expression: "companyType"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm6: "", xs12: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "Dispatched Driver",
                                          value: "Company Driver"
                                        },
                                        model: {
                                          value: _vm.companyType,
                                          callback: function($$v) {
                                            _vm.companyType = $$v
                                          },
                                          expression: "companyType"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm6: "", xs12: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "Owner/Operator",
                                          value: "Trucking Company/Owner Op"
                                        },
                                        model: {
                                          value: _vm.companyType,
                                          callback: function($$v) {
                                            _vm.companyType = $$v
                                          },
                                          expression: "companyType"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  staticClass: "pl-3",
                                  attrs: { row: "", wrap: "" }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm12: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            "Your Position at " +
                                            _vm.companyName
                                        },
                                        model: {
                                          value: _vm.companyPosition,
                                          callback: function($$v) {
                                            _vm.companyPosition = $$v
                                          },
                                          expression: "companyPosition"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm12: "" } },
                                    [
                                      _c("v-textarea", {
                                        attrs: {
                                          label:
                                            "Anything else about " +
                                            _vm.companyName
                                        },
                                        model: {
                                          value: _vm.notes,
                                          callback: function($$v) {
                                            _vm.notes = $$v
                                          },
                                          expression: "notes"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent" },
                          on: { click: _vm.createTemporaryAccount }
                        },
                        [_vm._v("\n          Create Interim Account\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.currentStep = 2
                            }
                          }
                        },
                        [_vm._v("Back")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-stepper-content",
                { attrs: { step: "4" } },
                [
                  _c("h1", { staticClass: "text-xs-center" }, [
                    _vm._v("You're set up!")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-xs-center" }, [
                    _vm._v("\n            We will contact you soon. "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.isLoadboardEnabled
                      ? _c("span", [
                          _vm._v(
                            "While you wait, what would you like to do next?"
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.isLoadboardEnabled
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { "mx-3": "" } },
                                [
                                  _c("h2", { staticClass: "text-xs-center" }, [
                                    _vm._v("Post a Load")
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-xs-center" }, [
                                    _vm._v("Start getting bids on your load.")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        to: "/post-load",
                                        block: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Post New Load\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { "mx-3": "" } },
                                [
                                  _c("h2", { staticClass: "text-xs-center" }, [
                                    _vm._v("Bid on a Load")
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-xs-center" }, [
                                    _vm._v("Find available loads to haul.")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        to: "/",
                                        block: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Search Load Board\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-layout",
                        [
                          _c("v-flex", { attrs: { xs12: "", sm4: "" } }),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { "mx-3": "" } },
                                [
                                  _c("h2", { staticClass: "text-xs-center" }, [
                                    _vm._v("Create a Load")
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-xs-center" }, [
                                    _vm._v("Start planning your loads now.")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        to: "/post-load",
                                        block: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Create New Load\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-534b7327", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-534b7327","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/User/Onboard.vue
// module id = null
// module chunks = 